var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1346 10.8175C36.1346 16.3771 31.7242 21.0457 25.8274 21.0457C20.2237 21.0457 15.4963 16.3771 15.4963 10.8175C15.4963 4.96828 20.2237 0.588242 25.8274 0.588242C31.7242 0.588242 36.1346 4.96828 36.1346 10.8175ZM43.5178 50C44.6872 50 45.2715 49.1335 45.2715 48.2434V32.7431C45.2715 28.6516 42.0314 25.4267 37.9131 25.4267H14.0348C9.89265 25.4267 6.35952 28.6516 6.35952 32.7431V48.2434C6.35952 49.1335 7.23666 50 8.13816 50H43.5178Z",
    fill: "#CC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9385 32.2161C34.7262 32.2019 34.5184 32.2843 34.3717 32.4408L33.238 33.5786C32.9354 33.895 32.9354 34.3999 33.238 34.7165L36.3905 37.9331L39.5566 34.7165C39.8615 34.3999 39.8615 33.895 39.5566 33.5786L38.4794 32.4408C38.3372 32.2866 38.1339 32.2042 37.9262 32.2161C37.7139 32.1999 37.5039 32.2827 37.3593 32.4408L36.4335 33.3819L35.5211 32.4408C35.363 32.2923 35.1553 32.2118 34.9385 32.2161Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0654,
    cy: 10.8824,
    rx: 10.8824,
    ry: 10.8824,
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c3ea72108e5f90afbe5ef539479294ae.svg";
export { ForwardRef as ReactComponent };